import { CampaignActions, CampaignEditRequest } from "../domain/campaign";
import { editCampaignService } from "../infrastructure/services/editCampaignService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const editCampaign = {
  async execute(
    campaignName: string,
    image: File | null,
    image1: File | null,
    image2: File | null
  ): Promise<void> {
    const request: CampaignEditRequest =
      await CampaignActions().editCampaignRequest(
        campaignName,
        image,
        image1,
        image2
      );
    await editCampaignService.execute(await tokenValidation.execute(), request);
  },
};
